import { computed } from 'vue';
import { useTypedStore } from '@/store';



export function usePermissions() {

  const store = useTypedStore();
  const currentAcl = computed(() => store.getters['auth/currentAcl']);
  const adminAcl = computed(() => store.getters['auth/adminAcl']);

  const hasPermission = (permission: string) => {
    // @ts-ignore
    return (currentAcl.value[permission] !== 'deny' || adminAcl.value.is_superuser);
  }

  return { hasPermission };
}
